"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildBaseProductFilter;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var getTaxonomies = function getTaxonomies(taxonomies) {
  return Array.isArray(taxonomies) && taxonomies.length ? {
    taxonomies: {
      $all: taxonomies
    }
  } : {};
};

function buildBaseProductFilter(_ref) {
  var _extends2;

  var currency = _ref.currency,
      ignorePrice = _ref.ignorePrice,
      locale = _ref.locale,
      _ref$priceGroup = _ref.priceGroup,
      priceGroup = _ref$priceGroup === void 0 ? '_default' : _ref$priceGroup,
      taxonomies = _ref.taxonomies;
  return (0, _extends3.default)((_extends2 = {}, (0, _defineProperty2.default)(_extends2, "name.".concat(locale), {
    $exists: true,
    $ne: []
  }), (0, _defineProperty2.default)(_extends2, "sku", {
    $exists: true,
    $ne: ''
  }), _extends2), ignorePrice ? {} : (0, _defineProperty2.default)({}, "_pricing.".concat(priceGroup, ".priceWithTax.").concat(currency), {
    $exists: true,
    $gt: 0
  }), getTaxonomies(taxonomies));
}